<template lang="pug">
  a.arrowbutton(v-on:click.prevent="goDown", :class="`direction-${direction}`")
    ArrowIcon
    span(v-if="text") {{text}}
</template>
<script>
import ArrowIcon from '@/components/ArrowIcon'

export default {
  props: {
    text: String,
    direction: String
  },
  components: {
    ArrowIcon
  },
  methods: {
    goDown() {
      window.scrollTo({
        top: window.innerHeight,
        behavior: 'smooth'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  a{
    display: flex;
    padding: 0.8rem;
    cursor: pointer;
    animation: bounce 3s infinite;

    align-items: center;
    justify-content: center;
    flex-direction: column;
    span{
      background: #ffea00;
      color: black;
      text-shadow: none;
      padding: 2px 4px;
    }
    &.direction-down{
      flex-direction: column-reverse;
    }
  }
  @keyframes bounce {
    0%, 18%, 25%, 30%, 50%, 55%, 100% {
      transform: translateY(0);
    }
    22% {
      transform: translateY(20px);
    }
    33% {
      transform: translateY(5px);
    }
  }
</style>


